// import "./App.css";
import React, { useEffect, useState, useRef } from "react";
import ExotelCRMWebSDK from "exotel-ip-calling-crm-websdk";
import styles from "../../assets/stylesheets/pages/tools/tools.module.scss";
import ProjectTitle from "../../components/common/ProjectTitle";
import ApiActions from "../../actions/ApiActions";
import jwt_decode from "jwt-decode";
import capitalise from "../../helper/Capitalise";
import { ErrorIcon } from "../../assets/images";

function VoipDialer(props) {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [callActive, setCallActive] = useState(false);
  const [isDeviceRegistered, setIsDeviceRegistered] = useState(false);
  const [isOnHold, setIsOnHold] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const webPhone = useRef(null);
  const [voipRegisteredUser, setVoipRegisteredUser] = useState({});

  const HandleCallEvents = (eventType, ...args) => {
    // console.log("HandleCallEvents", eventType, { args });
    /**
     * args[0] is the call object that should look like this
     * {
        "callAnswerTime": "",
        "callDirection": "",
        "callDuration": "",
        "callEndReason": "",
        "callEndedTime": "",
        "callEstablishedTime": "",
        "callFromNumber": "userxyz",
        "callId": "xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx@pstn.example.com",
        "callSid": "xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx",
        "callStartedTime": "",
        "callState": "",
        "remoteDisplayName": "",
        "remoteId": "",
        "sessionId": ""
      }
     */
    switch (eventType) {
      case "incoming":
        if (webPhone.current) {
          webPhone.current.AcceptCall();
          setCallActive(true);
        }
        break;
      case "connected":
        setCallActive(true);
        break;
      case "callEnded":
        setCallActive(false);
        break;
      case "holdtoggle":
        handleToggleOnHold();
        break;
      // eslint-disable-next-line no-fallthrough
      default:
        break;
    }
  };

  const RegisterationEvent = (event) => {
    if (event === "registered") {
      setIsDeviceRegistered(true);
      return;
    }
    if (event === "unregistered") {
      setIsDeviceRegistered(false);
    }
  };

  const registerUserVoip = async () => {
    try {
      let user = await ApiActions.registerUserVoip();
      setVoipRegisteredUser(user.data);
      await initializeWebPhone(user.data.appToken, user.data.appUserId);
    } catch (err) {
      console.error(err.response);
    }
  };

  const initializeWebPhone = async (appToken, appUserId) => {
    if (webPhone.current) return;

    // console.log("initialising crmWebPhone", { webPhone });
    const crmWebSDK = new ExotelCRMWebSDK(appToken, appUserId, true);
    // console.log("crmWebSDK", crmWebSDK);

    const crmWebPhone = await crmWebSDK.Initialize(
      HandleCallEvents,
      RegisterationEvent
    );
    // console.log("initialised crmWebPhone", { crmWebPhone });

    webPhone.current = crmWebPhone;
  };

  useEffect(() => {
    (async () => {
      await registerUserVoip();
    })();
  }, []);

  const handlePhoneNumberChange = (event) => {
    setPhoneNumber(event.target.value);
  };

  const dialCallback = (status, response) => {
    console.log("dialCallback response", { response });
    /** Response format is
     * {
          "CustomerId": "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx",
          "AppId": "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx",
          "CallSid": "xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx",
          "ExotelAccountSid": "exoteltestaccount",
          "DialWhomNumber": "xxxxxxxxxx",
          "AppUserID": "user123",
          "VirtualNumber": "xxxxxxxxxx",
          "Direction": "outbound",
          "CallStatus": "",
          "CallState": "active",
          "ToNumber": "xxxxxxxxxx",
          "FromNumber": "sip:userxyz",
          "TotalDuration": 0,
          "CallRecordings": "",
          "AccountDomain": "Mumbai",
          "TicketId": "",
          "CallDetail": null,
          "CreatedAt": "0001-01-01T00:00:00Z",
          "UpdatedAt": "0001-01-01T00:00:00Z"
        }
    */
    console.log("dialCallback status", status);

    if (status === "success") {
      const { CallSid, ToNumber } = response.Data;
      const { id, voipId } = voipRegisteredUser;
      const callReason = props.callReason.value;

      const data = {
        CustomField: JSON.stringify({
          admin: id,
          calleNumber: ToNumber,
          teamCallAccount: "ops",
          callReason,
          voipId,
        }),
        CallSid,
        public: true,
      };

      ApiActions.getCall(data);
    }
  };

  const dial = async () => {
    setErrorMsg("");
    if (!props.callReason) {
      setErrorMsg("Please select the call reason");
      return;
    }

    try {
      let result = await ApiActions.getTeleCallerDetails(phoneNumber);

      if (result) {
        setCallActive(true);
        webPhone &&
          webPhone.current &&
          webPhone.current.MakeCall(phoneNumber, dialCallback);
      }
    } catch (err) {
      setErrorMsg("Please enter registered mobile number");
    }
  };

  const hangup = () => {
    webPhone && webPhone.current && webPhone.current.HangupCall();
    setCallActive(false);
  };

  const handleToggleOnHold = () => {
    if (isOnHold) {
      setIsOnHold(false);
      return;
    }
    setIsOnHold(true);
  };

  const onClickToggleHold = () => {
    webPhone && webPhone.current && webPhone.current.ToggleHold();
    setIsOnHold(!isOnHold);
  };

  return (
    <div className={styles["app"]}>
      {!isDeviceRegistered ? (
        "WebSDK is initializing, please wait."
      ) : (
        <>
          <input
            className={styles["phoneNumberInput"]}
            type="text"
            id="phoneNumber"
            placeholder="Enter phone number"
            pattern="^\+?[0-9]{10,14}$"
            title="Please enter a valid phone number (10-14 digits, optional +)."
            onChange={handlePhoneNumberChange}
          ></input>
          {errorMsg ? (
            <span className={styles["error-msg"]}>
              <img
                src={ErrorIcon}
                alt="alert"
                style={{ width: "22px", marginRight: "3px" }}
              />
              {errorMsg}
            </span>
          ) : null}
          <div className={styles["PhoneControls"]}>
            {!callActive && (
              <button className={styles["dial"]} onClick={dial}>
                Dial
              </button>
            )}

            {callActive && (
              <>
                <button
                  className={styles["hold-unhold"]}
                  onClick={onClickToggleHold}
                  disabled={!callActive}
                >
                  {isOnHold ? "Unhold" : "Hold"}
                </button>
                <button
                  className={styles["hangup"]}
                  onClick={hangup}
                  disabled={!callActive}
                >
                  Hangup
                </button>
              </>
            )}
          </div>
        </>
      )}
      <span className={styles["label"]}>
        Call placed by: {voipRegisteredUser.sipId} |{" "}
        {capitalise(voipRegisteredUser.firstname) || "NA"}
      </span>
    </div>
  );
}

export default VoipDialer;
